Object.defineProperty(exports,"__esModule",{value:true});exports.formatDateUTC=exports.formatTime=undefined;exports.













































formatDate=formatDate;var _momentTimezone=require('moment-timezone');var _momentTimezone2=_interopRequireDefault(_momentTimezone);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var calendar={sameDay:'[Today]',lastDay:'[Yesterday]',lastWeek:'dddd',lastSixMonths:'MMMM D',sameElse:'MMMM D, YYYY'};var shortCalendar={sameDay:'LT',lastDay:'[Yesterday]',lastWeek:'ddd',lastSixMonths:'MMM D',sameElse:'l'};var isTimezoneValid=function isTimezoneValid(timezone){return _momentTimezone2.default.tz.zone(timezone);};var wrapDate=function wrapDate(date,timezone){return isTimezoneValid(timezone)?(0,_momentTimezone2.default)(date).tz(timezone):(0,_momentTimezone2.default)(date);};function formatDate(date,format){var timezone=arguments.length>2&&arguments[2]!==undefined?arguments[2]:null;

date=wrapDate(date,timezone);
var diff=date.clone().startOf('day').diff((0,_momentTimezone2.default)(),'days');
switch(format){
case'shortRelative':
return diff>-180&&diff<-6?date.format(shortCalendar.lastSixMonths):date.calendar(null,shortCalendar);
case undefined:
case null:
case'relative':
return diff>-180&&diff<-6?date.format(calendar.lastSixMonths):date.calendar(null,calendar);
case'fixed':
return date.format('l');
default:
return date.format(format);}

}

var formatTime=exports.formatTime=function formatTime(date,timezone){return wrapDate(date,timezone).format('LT');};

var formatDateUTC=exports.formatDateUTC=function formatDateUTC(date,format){return formatDate(_momentTimezone2.default.utc(date),format);};


//////////////////
// WEBPACK FOOTER
// ../~/inbox-common/dist/formatDate.js
// module id = 787
// module chunks = 0